<div class="left-side-content">
  <div class="slider-block">
    <div class="agenzee-info-slider">
      <div class="agenzee-slider-data">
        <div class="agenzee-slider-image">
          <div class="slider-images">
            <img src="../assets/images/login-agenzee-img.svg" class="res-img" alt="slider image" />
          </div>
        </div>
        <div class="agenzee-slider-details">
          <div class="agenzee-title-text">
            <h1 class="agenzee-title">Agenzee</h1>
            <p class="agenzee-text" *ngIf="descVersion != TenantType.Individual">
              InsurTech built to simplify licensing management, helping the insurance ecosystem efficiently track licenses and appointments while keeping information organized, up to date, and easy to manage — all in one place.
              <!-- Insurtech that will help ease the burden of agent licensing, appointments, and terminations to help your company stay 100% compliant with insurance regulations. -->
            </p>
            <p class="agenzee-text" *ngIf="descVersion == TenantType.Individual">
              InsurTech designed to simplify your licensing experience by helping Solo Producers efficiently track licenses and appointments, making it easier to stay organized and aligned with insurance regulations, all in one place.
            </p>
          </div>
        </div>
      </div>
     </div>
  </div>
  <div class="mobile-logo">
    <img src="../assets/images/logo-text.svg" alt="slider image" />
 </div>
</div>

